import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIAcademic',
    label: 'SSBIAcademic',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
